import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { AsideMyinfo } from '../../_layout/aside-myinfo';
import server from '../../_api/backend';
import * as toast from '../../_store/slice/toast';
import { GetTableFooter } from '../../_component/tableFooter';
import { FormatToComma } from '../../_component/format-to-comma';

export function Shipping(props: RouteComponentProps) {
  const dispatch = useDispatch();
  const [items, setItems] = useState<any>([]);
  const [allItems, setAllItems] = useState<any[]>([]);
  const [meta, setMeta] = useState<any>({});
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [bank] = useState<string>('국민은행 054901-04-133407');
  const [addonId, setAddonId] = useState<string>('');
  const [bankhost] = useState<string>('조규백');
  const [stpayDf, setStpayDf] = useState<string>('');
  const [beyandDf, setBeyandDf] = useState<string>('');

  useEffect(() => {
    if (window.localStorage.getItem('token') === null) {
      props.history.push('/login');
    } else {
      // getShipping();
      getOrdersDetail();
      getDeliveryPrice();
    }
  }, [currentPage]);

  useEffect(() => {
    if (window.localStorage.getItem('token') !== null) {
      getAllShipping();
    }
  }, []);

  // 배송비 조회 API 호출
  const getDeliveryPrice = async () => {
    await server
      .getDelivery()
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          setStpayDf(payload[0].stpayDf);
          setBeyandDf(payload[0].beyandDf);
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  // 주문내역 조회 API 호출 (페이징용)
  // const getShipping = async () => {
  //   await server.getShippingOwn(currentPage, 10).then((payload) => {
  //     if (!payload) {
  //       dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
  //     } else if (payload.code === 260 || payload.code === 500) {
  //       dispatch(toast.error({ message: '파라미터 오류' }));
  //     } else {
  //       console.log('원래 잇던거', payload);
  //       setItems(payload.items);
  //       setMeta(payload.meta);
  //     }
  //   });
  // };

  // 주문내역 조회 API 호출 (페이징용)
  const getOrdersDetail = async () => {
    await server
      .getOrdersOwnDetail(currentPage, 10)
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          setItems(payload.items);
          setMeta(payload.meta);
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  // 전체 주문내역 조회 API 호출 (상세보기용)
  const getAllShipping = async () => {
    await server
      .getShippingOwn(currentPage, 100000)
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          setAllItems(payload.items);
        }
      })
      .catch((error) => {
        console.log(' @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ ');
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  // 주문내역 테이블 생성
  function createShippingList() {
    return (
      <div className="table">
        <ul className="row title">
          <li className="order-id">주문번호</li>
          <li className="book-title">상품명</li>
          <li className="price">도서금액</li>
          <li className="price">총 결제금액</li>
          <li className="date">주문일</li>
          <li className="status">주문상태</li>
        </ul>
        {shippingRow}
      </div>
    );
  }

  // 특정 주문내역을 클릭했을 경우 슬라이드 영역 생성 (detail View)
  const addon = (data: any) => {
    const array = [];
    for (let i = 0; i < allItems.length; i++) {
      if (allItems[i].orderCode === data) {
        array.push(allItems[i]);
      }
    }
    array.shift();
    setAddonId(data);
  };

  // 주문내역값 불러오기
  const shippingRow = items?.map((item: any, i: any) => (
    <div key={Math.random()}>
      <ul className="row">
        <li className="order-id">{item.orderCode}</li>
        <li className="book-title">
          {item.bookName}
          {items[i].item.length > 1 ? `외 ${items[i].item.length} 품목` : ''}
        </li>
        <li className="date">
          {item.bookPrice === undefined ? (
            <></>
          ) : (
            Number(Number(item.bookPrice) * Number(item.orderQty)).toLocaleString()
          )}
        </li>
        <li className="price" style={{ fontWeight: 600 }}>
          {Number(item.paymentAmount).toLocaleString()}
        </li>
        <li className="date">{new Date(item.paymentDate).toLocaleDateString()}</li>
        <li className="status" style={{ color: '#95a5a6' }} onClick={() => addon(item.orderCode)}>
          [상세보기]
        </li>
      </ul>
      {item.orderCode === addonId
        ? items[i].item?.map((detail: any) => (
            <div className="orderDetail" key={detail.id}>
              <ul className="row">
                <li className="order-id">-</li>
                <li className="book-title">{detail.bookName}</li>
                <li className="price">
                  {Number(Number(detail.bookPrice) * Number(detail.orderQty)).toLocaleString()}
                </li>
                <li className="price-emtpy">-</li>
                <li className="date">-</li>
                <li className="status">{detail.payState}</li>
              </ul>
            </div>
          ))
        : ''}
    </div>
  ));

  // 미사용중.
  const onClick = () => {};

  // Shipping 리턴값
  return (
    <main className="sub list list-order wrapper">
      <AsideMyinfo />
      <div className="content">
        <div className="breadscrumb">
          <>Home</>
          {' > '}
          <>회원정보</>
          {' > '}
          <>주문내역조회</>
        </div>
        <div className="title">
          <h2>주문내역조회</h2>
          <p>고객님의 주문내역을 확인하실 수 있습니다.</p>
          <p>
            계좌번호: ({bankhost}) {bank}
          </p>
          <br />
          <p className="waring" style={{ fontWeight: 'bold', color: 'tomato' }}>
            ※ 총 결제금액은 도서금액 + 배송비({FormatToComma(beyandDf)}원)가 포함된 금액입니다.
            <small style={{ color: '#5e5c67', fontWeight: 400 }}>
              {' '}
              (주문한 도서금액의 합이 {FormatToComma(stpayDf)}원 초과시, 배송비는 무료입니다.)
            </small>
          </p>
        </div>
        <section>
          {createShippingList()}
          {GetTableFooter(
            meta?.currentPage,
            meta?.totalPages,
            (page: number) => setCurrentPage(page),
            '',
            onClick,
            false
          )}
        </section>
      </div>
    </main>
  );
}
